module.exports = __webpack_public_path__ + "static/media/ic-discover-technical.103a8c06.svg";